export default {
  data: () => {},
  methods: {
    getReport() {
      const query = process.env.NODE_ENV === 'development' ? '?env=dev' : ''
      return fetch(
        `${process.env.VUE_APP_API2_URL}/specialties/${
          this.$store.getters.specialty
        }/reports/${this.reportType}${query}`,
        {
          method: 'POST',
          body: JSON.stringify(this.labeledLogs),
          headers: { 'Content-Type': 'application/json' }
        }
      )
        .then(res => {
          if (res.ok) {
            return res.text()
          } else {
            if (res.status === 400) {
              res.json().then(errorObj => {
                const errorText = (
                  errorObj || { detail: 'Error: Detail missing' }
                ).detail
                this.$store.dispatch('showErrorSnackbar', errorText)
              })
            } else {
              throw Error('Could not fetch report')
            }
          }
        })
        .then(res => {
          this.report = res
        })
        .catch(err => {
          window.console.log(err.message || 'Unhandled fetch error')
          this.$store.dispatch(
            'showErrorSnackbar',
            'Error getting Report, try again later'
          )
        })
    },
    getAvaliableReports() {
      const query = process.env.NODE_ENV === 'development' ? '?env=dev' : ''
      return fetch(
        `${process.env.VUE_APP_API2_URL}/specialties/${
          this.$store.getters.specialty
        }/reports${query}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        }
      )
        .then(res => {
          if (res.ok) {
            return res.json()
          } else {
            throw Error('could not fetch logbook')
          }
        })
        .then(res => {
          this.reportTypes = res
          this.loadingReporters = false
        })
        .catch(err => {
          this.reportTypes = []
          this.loadingReporters = false
          this.$store.dispatch(
            'showErrorSnackbar',
            'Error getting Report Types'
          )
        })
    }
  }
}
